import { render, staticRenderFns } from "./AddressSummary.vue?vue&type=template&id=b3735ca6&scoped=true"
import script from "./AddressSummary.vue?vue&type=script&lang=js"
export * from "./AddressSummary.vue?vue&type=script&lang=js"
import style0 from "./AddressSummary.vue?vue&type=style&index=0&id=b3735ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3735ca6",
  null
  
)

export default component.exports